import { render, staticRenderFns } from "./DispatchUserRoleAssign.vue?vue&type=template&id=15cdf704&scoped=true&"
import script from "./DispatchUserRoleAssign.vue?vue&type=script&lang=js&"
export * from "./DispatchUserRoleAssign.vue?vue&type=script&lang=js&"
import style0 from "./DispatchUserRoleAssign.vue?vue&type=style&index=0&id=15cdf704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cdf704",
  null
  
)

export default component.exports